import { Dialog, Loading } from 'quasar';

export function showErrorMessage(errorMessage : string) : void {
  Loading.hide();
  Dialog.create({
    title: 'Error',
    message: errorMessage,
  });
}
